/* YAMU CRO: Cart bundle upsell carousel */
(function () {
  'use strict';

  var FORMAT = window.YamuCupMoneyFormat || '${{amount}}';
  function formatMoney(cents) {
    cents = Number(cents) || 0;
    function num(decimals, thousands, decimalSep) {
      var value = (cents / 100).toFixed(decimals);
      var parts = value.split('.');
      var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      var rest = parts[1] ? decimalSep + parts[1] : '';
      return dollars + rest;
    }
    return FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, token) {
      switch (token) {
        case 'amount': return num(2, ',', '.');
        case 'amount_no_decimals': return num(0, ',', '.');
        case 'amount_with_comma_separator': return num(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(0, '.', ',');
        case 'amount_with_space_separator': return num(2, ' ', ',');
        default: return num(2, ',', '.');
      }
    });
  }

  function initRoot(root) {
    if (root.dataset.cupInit === 'true') return;
    root.dataset.cupInit = 'true';

    var track = root.querySelector('[data-cup-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-cup-slide]'));
    var prev = root.querySelector('[data-cup-prev]');
    var next = root.querySelector('[data-cup-next]');
    var currentEl = root.querySelector('[data-cup-current]');
    var msg = root.querySelector('[data-cup-msg]');
    var total = slides.length;
    var index = 0;
    var adding = false;

    function render() {
      if (track) track.style.transform = 'translateX(' + (-index * 100) + '%)';
      if (currentEl) currentEl.textContent = index + 1;
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= total - 1;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
    }

    function go(delta) {
      index = Math.max(0, Math.min(total - 1, index + delta));
      render();
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    // per-slide variant price sync
    root.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-cup-variant]');
      if (!sel || sel.tagName !== 'SELECT') return;
      var slide = sel.closest('[data-cup-slide]');
      var opt = sel.options[sel.selectedIndex];
      var priceEl = slide && slide.querySelector('[data-cup-price]');
      if (opt && priceEl) priceEl.textContent = formatMoney(opt.getAttribute('data-price'));
    });

    function variantId(slide) {
      var el = slide.querySelector('[data-cup-variant]');
      if (!el) return null;
      if (el.tagName === 'SELECT') {
        var opt = el.options[el.selectedIndex];
        if (opt && opt.disabled) return null;
        return Number(el.value);
      }
      return Number(el.value);
    }

    function showMsg(text, kind) {
      if (!msg) return;
      msg.textContent = text;
      msg.className = 'yamu-cup__msg' + (kind ? ' is-' + kind : '');
      msg.hidden = false;
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cup-add]');
      if (!btn || adding) return;
      var slide = btn.closest('[data-cup-slide]');
      var id = variantId(slide);
      if (!id) { showMsg('Please choose an available size.', 'error'); return; }

      adding = true;
      var label = btn.querySelector('.btn__text');
      var original = label ? label.textContent : '';
      if (label) label.textContent = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Could not add to cart.'); });
          return r.json();
        })
        .then(function () {
          // Re-render the drawer; the upsell recomputes and drops this item.
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function (err) {
          showMsg(err.message || 'Could not add to cart.', 'error');
          if (label) label.textContent = original;
          btn.disabled = false;
          adding = false;
        });
    });

    render();
  }

  function init() {
    document.querySelectorAll('yamu-cart-upsell').forEach(initRoot);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Cart drawer re-renders replace the node, so re-init after each cart update.
  document.addEventListener('shopify:section:load', init);
  if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(init, 0);
    });
  }
})();
